export default "__VITE_ASSET__4f5a54fd__"